import dayjs from 'dayjs';
import { DATE_FORMAT } from "../constants";

export const formatDate = (date, format = DATE_FORMAT) => dayjs(date).format(format);
